import React, { createContext, useRef } from 'react'

export const ScrollSyncContext = createContext<any>(null)

export function ScrollSyncProvider({
   children,
}: {
   children: React.ReactNode
}) {
   const scrollRefs = useRef<any[]>([])

   return (
      <ScrollSyncContext.Provider value={scrollRefs}>
         {children}
      </ScrollSyncContext.Provider>
   )
}
